<template>
  <div>
    <!-- cw -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" width="500px" center>
      <div class="allot">
        <div class="item" v-for="(item, index) in cwData" :key="index">
          <p>
            {{ index + 1 }}.{{ item.realname }}樣[ID:{{ item.user_id }}]
          </p>
          <p>群组成员: <span v-for="(items, indexs) in item.group">{{ items }},</span> </p>
        </div>
        <div class="text">是否按上述信息创建CW群组?</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <el-button type="primary" @click="batchCreation">创建</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    selectList: { type: Array },
    cwData: { type: Array },
  },
  data() {
    return {
      //   批量分配
      dialogVisible: false,

    };
  },


  methods: {

    // 分配
    batchCreation() {
      let datas = {
        user: [],
      };
      this.selectList.forEach((item) => {
        datas.user.push(item.id)
      });
      this.$api.noticeApi.batchCreation(datas).then((res) => {
        this.dialogVisible = false
        if (res.msg != '操作成功') {
          return this.$alert(res.msg, '提示', {
            dangerouslyUseHTMLString: true,
          });
        }

        this.$message.success(res.msg)
        this.$parent.clientList();
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.allot {
  font-size: 16px;

  .item {
    margin-bottom: 30px;
  }

  .text {
    text-align: center;
    font-weight: bold;
  }
}
</style>